import React, { Component } from 'react';
//import { searchQuery } from '../../../store/actions/clientActions';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';

class InputAutocomplete extends Component {
	/*constructor(props){
		super(props);

	}*/

	handleKeyInput(input){
		//this.props.searchQuery(input);
	}

	filterSearch(input){

	}

	render() {

	    return (
	    	<Input 
	    		onKeyUp={(e) => this.props.handleKeyInput(e)}
	    		placeholder={this.props.placeholder}
	    		value={this.props.query}
	    	/>
	    )
	}
}


/*const mapStateToProps = (state) => {
	return {
		query: state.query,
	};
}
*/
const mapDispatchToProps = (dispatch) => {
	return {
		//searchQuery: (input) => dispatch(searchQuery(input))
	}
}

export default connect(mapDispatchToProps)(InputAutocomplete);



// WEBPACK FOOTER //
// ./src/views/Plugins/InputAutocomplete/InputAutocomplete.js